module.exports = __webpack_public_path__ + "img/video.4393203e.svg";